/**
 * The single source for Fergmar's published company figures. Every www page, marketing-page
 * render component, and marketing-page editor reads from here.
 *
 * A figure that also exists as text inside a `marketing_pages` CMS row is NOT authoritative
 * there: the render components override the CMS stat blocks with the arrays below. Prose
 * inside a CMS row is still hand-edited and can drift from these values (#854 replaces the
 * whole arrangement with one live source).
 *
 * Values resolved by owner decision 2026-08-05: 2,000+ deals closed, founded 2007,
 * $137M AUM (interim, to be computed from investments records).
 */
export const foundedYear = 2007;
export const yearsInRealEstate = new Date().getFullYear() - foundedYear;
export const assetsUnderManagement = "$137M";
export const doorsUnderManagement = "1,000";
export const transactionsClosed = "2,000";
export const transactionVolume = "$500M";
export const retailSquareFootage = "320,000";
export const totalAssets = "130";
export const teamMembers = "50";

export const fergmarAssetMetrics = [
	{ value: `${assetsUnderManagement}+`, label: "Assets Under Management" },
	{ value: `${doorsUnderManagement}+`, label: "Doors Under Management" },
	{ value: `${yearsInRealEstate}+`, label: "Years in Real Estate" },
	{ value: `${transactionsClosed}+`, label: "Transactions Closed" }
];

export const fergmarTrackRecord = [
	{ value: `${transactionVolume}+`, label: "Transaction Volume" },
	{ value: `${transactionsClosed}+`, label: "Deals Closed" },
	{ value: `${assetsUnderManagement}+`, label: "Current Portfolio" },
	{ value: `Since ${foundedYear}`, label: "Track Record" }
];

export const fergmarPortfolioStats = [
	{ value: `${doorsUnderManagement}+`, label: "Apartment Units" },
	{ value: `${retailSquareFootage}+`, label: "SF Retail Space" },
	{ value: `${assetsUnderManagement}+`, label: "Assets Under Mgmt" },
	{ value: `${teamMembers}+`, label: "Team Members" }
];

/** Managing-partner bio stat grid. Shape matches the CMS `highlights` block it overrides. */
export const fergmarBioHighlights = [
	{
		amount: `${assetsUnderManagement}+ AUM`,
		description: `${doorsUnderManagement}+ Doors in Portfolio`
	},
	{ amount: `${teamMembers}+`, description: "Managed Team Members" },
	{ amount: `${yearsInRealEstate}+ Years`, description: "Experience in Real Estate" },
	{ amount: `${transactionsClosed}+`, description: "Deals Closed" }
];

/**
 * Meta descriptions for the marketing-page editors, which re-stamp them on every save.
 * They live here because they quote the figures above; a copy edited in the editor drifts
 * silently into the CMS row and out to search results.
 */
export const managingPartnerBioMetaDescription = `INC 5000 Team Builder, Real Estate Entrepreneur. ${transactionVolume}+ transactions, ${assetsUnderManagement}+ AUM. Experienced real estate investor and business manager.`;

export const closingCredentialsMetaDescription = `Established ${foundedYear} | Victoria, Texas. Fergmar Capital is a vertically integrated real estate investment firm with over ${transactionVolume} in transaction volume and ${transactionsClosed}+ deals closed.`;
